<template>
  <div id="pointshop-widget" class="turquoiseTheme" :class="{ 'notAvailableInYourCountry': notAvailableInYourCountry }">
    <div v-if="loaded">
      <p class="pointShopHeader">
        <!-- <i data-v-225a544c="" class="far fa-exclamation-circle" v-if="notAvailableInYourCountry"></i> -->
        <i class="fa-solid fa-hand-wave" v-if="notAvailableInYourCountry"></i>    
        {{ notAvailableInYourCountry ?  this.$root.language.wsm_welcomeNotAvailableInYourCountry : this.$root.language.wsm_pointShopHeader }}
      </p>
      <div class="pointShopCode">
        <label>{{ this.$root.language.wsm_InsertPointCodeHere }}</label>
        <div class="interactivePointWidgetParts" v-if="!notAvailableInYourCountry">
          <div class="codeTainer">
            <input title="Only numbers and letters" ref="part1" type="text" placeholder="- - -" maxlength="3"
              v-model="pointshopCode.part1" @input="checkLength(1, $event)" @keydown.space.prevent>
            <span class="splitter">-</span>
            <input title="Only numbers and letters" ref="part2" type="text" placeholder="- - -" maxlength="3"
              v-model="pointshopCode.part2" @input="checkLength(2, $event)" @keydown.space.prevent>
            <span class="splitter">-</span>
            <input title="Only numbers and letters" ref="part3" type="text" placeholder="- - -" maxlength="3"
              v-model="pointshopCode.part3" @input="checkLength(3, $event)" @keydown.space.prevent>
          </div>
          <button class="submitButton" :disabled="!unlockButton" @click="submitCode">
            OK <span v-if="false" class="pulse-dot"></span>
          </button>

          <button v-if="hasCamera && $root.pointvision" @click="showScanner = true">{{
            this.$root.language.wsm_pointvision_entercodewithcamera }}</button>
        </div>
        <div class="balanceContainer" v-if="!notAvailableInYourCountry">
          <p>{{ this.$root.language.wsm_YouHave }} <span v-if="!hasInputCode"
              :class="['pointBalance', animate ? 'pop' : '']">{{ pointInfo.points }}</span>
            <animated-number :class="['pointBalance', animate ? 'pop' : '']" :round="1" v-show="hasInputCode"
              :value="pointInfo.points" :formatValue="formatToPrice" :duration="1000" />
            {{ this.$root.language.wsm_PointsLeftBasket }}
          </p>
        </div>
        <p class="extraInfoCode" v-if="this.$root.language.wsm_extraInfoPointShopCode != 'wsm_extraInfoPointShopCode'"
          v-html="this.$root.language.wsm_extraInfoPointShopCode"></p>

        <messageModal v-if="message != '' && this.showModal == true" @close-clicked="closeModal()"
          :messageProp="message" :messageHeader="messageHeader" class="success-message"></messageModal>

        <messageModal v-if="errorMessage != '' && this.showModal == true" @close-clicked="closeModal()"
          :messageProp="errorMessage" :messageHeader="messageHeader" class="error-message"></messageModal>


        <div class="notAvailableInYourCountry" v-if="notAvailableInYourCountry">        

          <div v-html="this.$root.language.wsm_notAvailableInYourCountry"></div>
          <img class="notAvailableInYourCountryImage" :src="`${$root.basedir}/CKFinderJava/userfiles/images/Pointshop/QRcodeOfficialPN.png`" alt="Pharma Nord Official Website">
        </div>
      </div>
    </div>
    <scanner @closemodal="closemodal" @code-success="onScanSuccess" v-if="showScanner"></scanner>

  </div>
</template>

<script>

import axios from 'axios';
import AnimatedNumber from "animated-number-vue";
import messageModal from "./components/messageModal.vue";
import scanner from './components/googleVision.vue'
export default {
  name: 'Pointshop-code-insert',
  components: {
    AnimatedNumber,
    messageModal,
    scanner
  },
  data: function () {
    return {
      pointInfo: {
        points: "undefined",
      },
      message: '',
      hasInputCode: false,
      showScanner: false,
      hasCamera: false,
      animate: false,
      pointshopCode: {
        part1: '',
        part2: '',
        part3: '',
      },
      unlockButton: false,
      errorMessage: '',
      loaded: false,
      showModal: false,
      messageHeader: '',
      notAvailableInYourCountry: false,
    }
  },
  async created() {
    const isAvailableInYourCountry = await this.$store.dispatch('checkCountryAvailability');
    this.notAvailableInYourCountry = !isAvailableInYourCountry;
    this.loaded = true;

    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'applyPoints':
          this.pointInfo.points = state.pointBalance;
          break;
      }
    })

    this.pointInfo.points = this.$root.userpoints;

    if (!navigator.mediaDevices || !navigator.mediaDevices?.enumerateDevices) {
      this.hasCamera = false;
    } else {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          devices.forEach((device) => {
            if (device.kind == 'videoinput') {
              this.hasCamera = true;
            }
          });
        })
    }
  },
  mounted() {


    window.addEventListener("load", (event) => {
      let el_list_webbasket = document.querySelectorAll('.plusMinusBtn');   // qty buttons inside the basket           
      let el_list_buybuttoncompact = document.querySelectorAll('.buybuttonVue');   //buybuttoncompact      
      let el_addtobasket = document.querySelectorAll('.addToBasketButton'); // Add-to-basket buttons on products      

      let elList = [el_list_buybuttoncompact, ...el_addtobasket, ...el_list_webbasket]

      elList.forEach((el, index) => {
        if (el.length !== 0) { //skip empty NodeList        
          //add event listener so if any of the element in the list is clicked, we update the points on the widget 
          el.addEventListener('click', function handleClick(event) {
            this.$store.dispatch('updatePointShopWidget');
          });
        }
      });
    });

  },
  methods: {
    closemodal() {
      this.showScanner = false;
    },
    onScanSuccess() {
      this.hasInputCode = true;
      this.animate = true;
      setTimeout(() => {
        this.animate = false;
      }, 1000);
    },
    submitCode: function () {
      axios.get(this.$root.basedir + '/ajaxRequestServlet?mode=PointWidget&payload={"pointShopModuleMode":"PointShopCode",pointShopCode:' + encodeURI(this.finalCode) + ',"isPointShop":"Y"}', {
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then(response => {
        if (response.data.errorMessage != "") {
          this.errorMessage = response.data.errorMessage;
          this.showModal = true;
          this.messageHeader = '<i data-v-225a544c="" class="far fa-exclamation-circle"></i>';
        } else {
          axios.get(this.$root.basedir + '/ajaxRequestServlet?mode=PointWidget&payload={"pointShopModuleMode":"GetPoints","isPointShop":"Y"}').then(response => {
            this.hasInputCode = true;
            this.animate = true;
            this.pointInfo = response.data
            this.pointshopCode.part1 = ''
            this.pointshopCode.part2 = ''
            this.pointshopCode.part3 = ''
            setTimeout(() => {
              this.animate = false;
            }, 1000);
          })
          if (response.data.message != "") {
            this.message = response.data.message;
            this.messageHeader = '<i class="far fa-check-circle"></i>';
            this.showModal = true;
          }
        }
      }).catch(error => {
        this.errorMessage = this.$root.language.wsm_InvalidCode
      })
    },


    checkLength: function (part, event) {
      this.errorMessage = '';
      this.message = '';

      // Remove any spaces that might have been pasted
      if (this.pointshopCode["part" + part].includes(' ')) {
        this.pointshopCode["part" + part] = this.pointshopCode["part" + part].replace(/\s/g, '');
      }

      if (this.pointshopCode["part" + part].length == 0 && part != 1 && event.inputType == "deleteContentBackward") {
        this.$refs["part" + (part - 1)].focus();
        this.$refs["part" + (part - 1)].setSelectionRange(3, 3);
      }
      if (this.pointshopCode["part" + part].length >= 3 && part != 3) {
        this.$refs["part" + (part + 1)].focus();
        this.$refs["part" + (part + 1)].setSelectionRange(0, 0);
      }

      this.unlockButton = Object.keys(this.pointshopCode).every(key => this.pointshopCode[key].length === 3);
    },
    //this function is used to update the basket on the page that includes the pointshop widget(it is called in common.js)
    getPoints: function () {
      this.$store.dispatch("updatePointShopWidget");
    },
    formatToPrice(value) {
      return `${value}`;
    },
    closeModal() {
      this.showModal = false;
    }
  },
  computed: {
    finalCode: function () {
      return this.pointshopCode.part1 + "-" + this.pointshopCode.part2 + "-" + this.pointshopCode.part3;
    }
  }
}
</script>

<style scoped lang="scss">
#pointshop-widget {
  max-width: 400px;

  &.notAvailableInYourCountry {
    max-width:600px;
    .notAvailableInYourCountryImage {
      width: 100%;
      height: auto;
    }

    .pointShopHeader {
      text-align: center;    
      font-size: 16px !important;
    
     i {
      color: white;
      font-size: 20px;
      margin-right: 10px;
     }
    }
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.pointShopCode {
  width: auto;
  border: 1px solid #d5d5d5;
  padding: 5%;
  margin-bottom: 13px;
  border-top: none;

  .balanceContainer {
    height: auto;
    position: relative;
    margin-bottom: 12px; // margin-top: -12px;

    &>p {
      // position: absolute;
      bottom: -1px;
      margin: 0;
    }
  }

  .pointBalance {
    font-weight: bold;
    color: #7caf63;
  }

  label {
    text-align: left;
  }

  input {
    border: 1px solid #7caf63;
    margin-top: 4px;
    margin-bottom: 7px;
    font-weight: 900;
    font-size: 1em;
    color: #004570;
    vertical-align: top;
    height: 14px;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 9px 3px 9px 4px;
    width: 23%;
    display: inline-block;
    text-align: center;

    &::placeholder {
      color: #c1c1c1;
    }
  }

  .interactivePointWidgetParts {
    text-align: left;

    button {
      display: inline-block;
      width: 100%;
      background: #7caf63;
      border: 1px solid #6b9a54;
      color: white;
      padding: 3px;
      vertical-align: top;
      cursor: pointer;
      height: auto;
      margin-top: 4px;
      cursor: pointer;
      font-size: 17px;
      margin-bottom: 10px;

      &:hover {
        background: #8bc070;
      }

      &:disabled {
        opacity: 0.7;

        &:hover {
          cursor: not-allowed;
          background: #7caf63;
        }
      }
    }
  }

  .codeTainer {
    .splitter {
      display: inline-block;
      font-weight: bold;
      color: #004570;
      font-size: 29px;
      height: 28px;
      width: 5%;
      text-align: center;
      margin-left: 5px;
      margin-right: 5px;
      padding-top: 9px;
    }
  }
}

.pointShopHeader {
  background: #004570;
  color: white;
  padding: 10px;
  width: auto;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  margin-bottom: 0;
}

.error {
  font-size: 12px;
  color: #ff4444;
  font-weight: bold;
  border: 1px solid #efb9b9;
  padding: 8px;
  border-radius: 6px;

  i {
    color: #ff4444;
  }
}

.message {
  font-size: 12px;
  color: #7caf63;
  font-weight: bold;
  border: 1px solid #9ccc83;
  padding: 8px;
  border-radius: 6px;

  i {
    color: #7caf63;
  }
}

@keyframes scaling {
  0% {
    font-size: 15px;
  }

  50% {
    font-size: 17px;
  }

  100% {
    font-size: 15px;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.pulse-dot {
  display: inline-block;
  width: 25px;

  height: 18px;
  background-color: transparent;
  border-radius: 50%;
  position: absolute;
  animation: pulse 1.5s infinite;
  vertical-align: middle;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

.submitButton:disabled .pulse-dot {
  opacity: 0;
}

.pop {
  animation-name: scaling;
  animation-duration: 1s;
}

@media screen and (max-width: 915px) {
  .pointShopCode {
    .interactivePointWidgetParts {
      button {
        height: 34px;
      }
    }

    input {
      font-size: 0.6em;
      width: 20%;
    }
  }
}

@media screen and (max-width: 700px) {
  .pointShopCode {
    .interactivePointWidgetParts {
      button {
        height: 34px;
      }
    }

    input {
      font-size: 0.8em;
      width: 24%;
    }
  }
}


.turquoiseTheme {
  .notAvailableInYourCountry {
    border-radius: 5px;
    margin-bottom: 10px;

   ::v-deep p {
    color: white;
   }
    
  }
  .pointShopHeader,
  .infobox.blue .infoboxHeader {
    background: #418a90;
  }

  .pointShopHeader {
    font-weight: 700;
    border-bottom: 1px solid #eaeaea;
    padding: 10px 15px;

    i {
      color: white;
    }
  }

  .pointShopCode {
    background-color: #418a90;
  }


  .balanceContainer {
    p {
      color: white;
    }

    .pointBalance {
      color: #f2dc55;
    }
  }


  input {
    border: 1px solid #56b0b7;
  }

  .interactivePointWidgetParts {

    .codeTainer {
      .splitter {
        color: white;
      }
    }

    button {
      background: #418a90;
      border: 1px solid white;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: #418a90;
      }

      &:disabled {
        opacity: 0.5;

        &:hover {
          background: #2e6267;
        }
      }
    }
  }

  .error {
    background-color: white;
  }
}
</style>
<style lang="scss">
.extraInfoCode {
  color: gray;
  font-size: 12px;

  a {
    font-size: 12px;
  }
}
</style>